import { ReactNode, useRef } from "react";

import { useOnScreen } from "../../hooks/UI";
import "./Title.scss";

interface Props {
  text?: string | number | ReactNode;
  suffix?: string;
  className?: string;
  inverted?: boolean;
  animate?: boolean;
  suffixInNewLine?: boolean;
  spaceBetween?: boolean;
}

export const Title = ({
  text,
  suffix,
  className = "",
  inverted,
  animate,
  suffixInNewLine,
  spaceBetween = true,
}: Props) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const isVisible = useOnScreen(ref);

  return (
    <h2
      ref={ref}
      className={`title ${animate ? "title--animate" : ""} ${
        inverted ? "title--inverted" : ""
      } ${isVisible ? "title--visible" : ""} ${className}`}
    >
      {text}
      {spaceBetween ? " " : ""}
      {suffix && (
        <span
          className={`title__suffix ${
            suffixInNewLine ? "title__suffix-new-line" : ""
          }`}
        >
          {suffix || ""}
        </span>
      )}
    </h2>
  );
};
